var moduleMap = {
	"./pages-map": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map */ 4384).then(function() { return function() { return (__webpack_require__(2454)); }; });
	},
	"./pages-map-v2": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map_v2 */ 3749).then(function() { return function() { return (__webpack_require__(392)); }; });
	},
	"./pages/index": function() {
		return Promise.all(/* __federation_expose_pages__index */[__webpack_require__.e(4761), __webpack_require__.e(5979), __webpack_require__.e(5381), __webpack_require__.e(1944)]).then(function() { return function() { return (__webpack_require__(2408)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});